var subscribeFAQ = function(){
  var items;

  var _init = function(){
    items = document.getElementsByClassName('m-subscribe-faq-item');

    [].map.call(items, function(item){
      item.addEventListener('click', _createAnswer);
    });  
  }

  var _createAnswer = function(e){
    var _this = e.currentTarget;
    var iframe;

    if (!_this.dataset.set) {
      iframe = _createIframe(_this.dataset.iframe);
      _appendToAnswer(_this, iframe);

      _this.dataset.set = true;
    }

    _toggleAnswer(_this);
  }

  var _toggleAnswer = function(el){
    el.classList.toggle('open');
  };

  var _createIframe = function(data){
    var iframe = document.createElement('iframe');
    iframe.src = data;
    return iframe;
  };

  var _appendToAnswer = function(el, iframe){
    var wrap = el.getElementsByClassName('m-subscribe-faq-item__answer')[0];
    wrap.appendChild(iframe);
  };

  return {
    init: _init
  }

}();

if (document.getElementsByClassName('m-subscribe-faq-item').length) {
  subscribeFAQ.init();
}